export default "__VITE_ASSET__B6hLM1Vd__"